export const API_SOURCE_LAST_USER_ORDERS = 'Last User Orders'
export const API_SOURCE_COVEO_POPULAR_ITEMS_BOUGHT = 'REC - Popular Items bought'
export const API_SOURCE_COVEO_CART_RECOMMENDER = 'REC - Cart Recommender'
export const API_SOURCE_COVEO_FREQUENTLY_BOUGHT_TOGETHER = 'REC - Frequently Bought Together'
export const API_SOURCE_HQ_RECOMMENDATION_HW = 'REC - HQ RECOMMENDATION'

export const COVEO_CLIENT_ORIGIN_SEARCH_API_FETCH = 'searchApiFetch'
export const COVEO_CLIENT_ORIGIN_ANALYTICS_FETCH = 'analyticsFetch'
export const COVEO_MAX_RESPONSE_TIME = 8000
